import React from "react";
import { MapPin, Activity, Shield, Server, Network, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
const networkHubs = [{
  id: "hq-1",
  name: "Main Operations Base",
  role: "Project Management HQ",
  location: "Central London District",
  status: "Active Site",
  icon: MapPin,
  x: 50,
  y: 50
}, {
  id: "node-2",
  name: "Surrey Development",
  role: "Residential New Builds",
  location: "South East Region",
  status: "In Progress",
  icon: Activity,
  x: 25,
  y: 35
}, {
  id: "node-3",
  name: "Kent Restoration",
  role: "Bespoke Renovations",
  location: "South East Region",
  status: "Completed",
  icon: Shield,
  x: 75,
  y: 45
}, {
  id: "node-4",
  name: "Essex Expansion",
  role: "Domestic Extensions",
  location: "East of England",
  status: "Planning",
  icon: Server,
  x: 65,
  y: 75
}];
export default function InnovationHeadquarters() {
  return;
}